<template>
	<div class="">
		<div class="bigview colonn rowsa center_center animate__animated animate__slideInRight">
			<div class="baixian yincang1"></div>
			<img  src="../../static/dinahu.png"
			 @mouseenter="changeImage(1,0)"
			 	@mouseleave="changeImage(2,0)"
			 	
			 class="iconim"/>
			<div class="baixian"></div>
			<img  src="../../static/qq.png" 
			 @mouseenter="changeImage(1,1)"
			 	@mouseleave="changeImage(2,1)"
			 class="iconim" style="margin:20rpx 0rpx;"/>
			<div class="baixian "></div>
			<img  src="../../static/erweima.png" 
			 @mouseenter="changeImage(1,2)"
			 	@mouseleave="changeImage(2,2)"
			 class="iconim"/>
			<div class="baixian yincang1"></div>
		</div>
		
		<div class="dianhuaview1 roww center_center"
		@mouseenter="changeImage(1,0)"
			@mouseleave="changeImage(2,0)"  v-if="type==0"
		>
			<div class="dianhuaview colonn rowsa" style="border:1px solid #f5f5f5;"
			>
				<div class="colonn border_bottom" style="font-size: 10px;padding-left: 15px;padding-bottom: 10px;">
					<div style="margin-top:5px;">热线电话</div>
					<div style="margin-top:5px;color: #999999;">0531-86160666</div>
				</div>
				<div class="colonn  border_bottom" style="font-size: 10px;padding-left: 15px;padding-bottom: 10px;">
					<div style="margin-top:5px;">上班时间</div>
					<div style="margin-top:5px;color: #999999;">周一到周五</div>
				</div>
				<div class="colonn  " style="font-size: 10px;padding-left: 15px;padding-bottom: 10px;">
					<div style="margin-top:5px;">E-mail地址</div>
					<div style="margin-top:5px;color: #999999;">2979882323@qq.com</div>
				</div>
			</div>
		</div>
		
		<div class="kefuqq"
		@mouseenter="changeImage(1,1)"
		@mouseleave="changeImage(2,1)" v-if="type==1"
		>
			<div class=" colonn" style="font-size: 10px;padding: 5px 20px 0px 20px;width:150px;height: 50px;" 
			>
				<div style="font-weight: bold;">客服中心</div>
				<div style="height: 5px;"></div>
				<div class="roww center_center" >
					<img style="width: 15px;height: 15px;" src="../../static/xiaoxi.png"/>
					<div style="width: 5px;"></div>
					<div>杨经理</div>
					<div class="allline"></div>
				</div>
			</div>
		</div>
		
		
		<div class="erweima" 
			v-if="type==2"
			@mouseenter="changeImage(1,2)"
		 	@mouseleave="changeImage(2,2)"
		>
			<div class=" colonn center_center" style="font-size: 10px;width: 120px;height: 120px;background-color: white;border-radius: 5px;border:1px solid #f5f5f5;" 
			>
				<img  src="../../static/wangzhanqr.png" style="width: 110px;height: 110px;"/>
			</div>
		</div>
		
		
		
	</div>
</template>

<script>

	export default {
		name: 'ComponentName', // 组件的名称
		components: {
			
		},

		data() {
			return {
				type:-1,
			}
		},

		props: {
			// 组件的属性
		},

		computed: {
			// 组件的计算属性
		},

		methods: {
			changeImage(type, index) {
				if(type==1){
					this.type=index;
				}else{
					this.type=-1;
				}
				
				
			},
		},

		mounted() {
			// 组件挂载后的操作
		},

	}
</script>

<style>
	@import url(lianxi.css);
</style>